<template>
  <div class="row text-left">
    <div class="col-12 col-lg-12">
      <div class="d-flex flex-column">
        <h6 class="tituloH6 color-trabalho bold mb-2">Competências gerais</h6>
        <p class="caption1 color-gray-400">
          Escreva habilidades ligadas com a vaga que você deseja.
        </p>
      </div>
      <div class="input-label">
        <text-to-tags :list="valueInternal.skillsValue" placeholder="Ex.: Liderança, vendas, trabalho em equipe."></text-to-tags>
        <p class="caption2 color-gray-400">
          Pressione a tecla Enter para adicionar uma nova habilidade.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TextToTags from './shared/InputTextTags.vue'

export default {
  name: "SkillsInputComponent",
  props: ['value'],
  components: {
    TextToTags,
  },
  computed: {
    valueInternal: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("update:value", value);
      },
    },
  },
};
</script>

<style scoped>
</style>
